import { CircularProgress, CSSProperties } from '@mui/material';
import { forwardRef } from 'react';
import { cssWhen } from '../../utils/themeUtils';
import classes from './Loader.module.scss';

const defaultIndefiniteLoaderHeight = 12;

export type NbLoaderProps = {
  verticalCenter?: boolean;
  horizontalCenter?: boolean;
  backdrop?: boolean;
  className?: string;
  size?: 'default' | 'small';
  dataTestId?: string;
};

export type NbIndefiniteLoaderProps = {
  className?: string;
  size?: 'default' | '100%' | number;
  height?: number;
  isTransparent?: boolean;
  isContrast?: boolean;
  dataTestId?: string;
};

export const NbLoader = forwardRef<HTMLDivElement, NbLoaderProps>(
  ({ horizontalCenter, verticalCenter, backdrop, className, size, dataTestId }: NbLoaderProps, ref) => {
    const loader = <CircularProgress size={size === 'small' ? classes.smallSize : classes.defaultSize} />;
    if (!horizontalCenter && !verticalCenter && !className) {
      return loader;
    }
    return (
      <div
        className={cssWhen(
          classes.loader,
          [className, className!],
          [horizontalCenter, classes.loaderIsHorizontallyCenter],
          [verticalCenter, classes.loaderIsVerticallyCenter],
          [backdrop, classes.loaderIsBackdrop],
        )}
        ref={ref}
        data-testid={dataTestId}
      >
        {loader}
      </div>
    );
  },
);

export const NbIndefiniteLoader = ({
  className,
  size,
  isTransparent,
  isContrast,
  dataTestId,
  height,
}: NbIndefiniteLoaderProps) => {
  const style: CSSProperties =
    typeof size === 'number' ? { width: size, height: height ?? defaultIndefiniteLoaderHeight } : {};

  return (
    <div
      style={style}
      data-testid={dataTestId}
      className={cssWhen(
        classes.indefiniteLoader,
        [className, className!],
        [size === '100%', classes.indefiniteLoaderFullWidth],
        [isTransparent, classes.indefiniteLoaderIsTransparent],
        [isContrast, classes.indefiniteLoaderIsContrast],
      )}
    ></div>
  );
};
